module.exports = __webpack_public_path__ + "videos/siconsulting-logo.c6812a3.webm";